import { render, staticRenderFns } from "./Arrrow.vue?vue&type=template&id=07cca05e"
import script from "./Arrrow.vue?vue&type=script&lang=js"
export * from "./Arrrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports